import { ChildProps } from '@/common/util/props'
import { HttpStatusCode } from '@/common/util/status'

import ContentEditLoading from '@/components/view/molecules/loading/ContentEditLoading'

import { ErrorPageInner } from '@/components/container/page/ErrorPage'

interface Props extends ChildProps {
  error: Response | { status: HttpStatusCode } | undefined
  data: any
  withSide?: boolean
}

const MainInnerLoader = ({ children, error, data, withSide = false }: Props) => {
  return (
    <>
      {error != undefined ? (
        <ErrorPageInner status={error.status} />
      ) : data === undefined ? (
        <ContentEditLoading center withSide={withSide} />
      ) : data === null ? (
        <ErrorPageInner status={HttpStatusCode.NOT_FOUND} />
      ) : (
        <>{children}</>
      )}
    </>
  )
}

export default MainInnerLoader
